import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { initialStageAvatarState } from "src/reducks/AvatarStageStore/initializes";

export const avatarStageSlice = createSlice({
  initialState: initialStageAvatarState,
  name: "avatarStage",
  reducers: {
    addAvatarStageImage: (state, action: PayloadAction<string>) => {
      state.stageImage = action.payload;
    },
  },
});

export const { addAvatarStageImage } = avatarStageSlice.actions;

export const avatarStageReducer = avatarStageSlice.reducer;
